import React from "react";

const defaultValue = {
    IframePostMessage() {},
    widgetSettings: {},
    visitorData: {}
};

export default React.createContext(defaultValue);
